
import Swal from 'sweetalert2'
import './swal.css'

export const swalAlert = (title, html, icon, confirmText, confirmCallback = false) =>
    Swal.fire({
        title: title,
        html: html,
        icon: icon,
        confirmButtonText: confirmText
    }).then((result) => {
        if (result.isConfirmed) { confirmCallback && confirmCallback(); }
    })

export const swalErrorAlert = (title = '', html = '', icon = '', confirmText = '', confirmCallback = false) =>
    Swal.fire({
        title: title ? title : 'Error',
        html: html ? html : '에러가 발생했습니다.<br> 에러가 반복되면 관리자에게 문의해 주세요.',
        icon: icon ? icon : 'error',
        confirmButtonText: confirmText ? confirmText : '확인',
    }).then((result) => {
        if (result.isConfirmed) { confirmCallback && confirmCallback(); }
    })

export const swalConfirm = (title, html, icon, confirmButtonText, cancelButtonText, confirmFunc, cancelFunc) => {
    Swal.fire({
        title: title,
        html: html,
        icon: icon,
        showCancelButton: true, // 취소 버튼 표시
        confirmButtonText: confirmButtonText,
        cancelButtonText: cancelButtonText,
        reverseButtons: true, // 버튼 순서 변경
    }).then(async (result) => {
        if (result.isConfirmed) {
            confirmFunc()
        } else {
            cancelFunc()
        }
    })
}

export const swalToast = Swal.mixin({
    toast: true,
    // position: 'center',
    position: 'bottom',
    iconColor: 'white',
    customClass: {
        popup: 'colored-toast',
    },
    showConfirmButton: false,
    timer: 1500,
    timerProgressBar: false,
})